import { Row, Col, Card, CardBody } from "reactstrap";
import React, { useEffect, useState } from "react";
import FIELDS from "./CONSTANT";
import { FieldInput } from "../../../../components/FieldInput";
import { useParams } from "react-router-dom";

export default function PoolForm({ validation }) {
  const { contractId } = useParams();
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setFields([]);

    FIELDS.map((f) => {
      if (f.key == "company_contracts" && contractId != "noId") {
        setFields((prev) => [...prev, { ...f, disabled: true }]);
      } else {
        setFields((prev) => [...prev, f]);
      }
    });
  }, [contractId]);
  
  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {fields?.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
